import BookingMenu from "../BookingMenu";
import TransitView from "./TransitView";

const TransitViewContainer = ({

}) => {
	return (
		<div>
			 <BookingMenu activeItem={2}/>
             <TransitView/>		
		</div>
	)
}

export default TransitViewContainer;